// src/services/watchlistService.js

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4000';

const headers = (email) => ({
  'Content-Type': 'application/json',
  'X-User-Email': email,
});

export async function fetchWatchlist(userEmail) {
  const res = await fetch(`${API_BASE}/api/watchlist`, {
    headers: headers(userEmail),
  });
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to fetch watchlist');
  return res.json();
}

export async function addToWatchlist(userEmail, symbol, companyName, exchange) {
  const res = await fetch(`${API_BASE}/api/watchlist`, {
    method: 'POST',
    headers: headers(userEmail),
    body: JSON.stringify({ symbol, companyName, exchange }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to add');
  return data;
}

export async function removeFromWatchlist(userEmail, symbol) {
  const res = await fetch(`${API_BASE}/api/watchlist/${symbol}`, {
    method: 'DELETE',
    headers: headers(userEmail),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Failed to remove');
  return data;
}

export async function fetchDailyBrief(userEmail) {
  const res = await fetch(`${API_BASE}/api/daily-brief`, {
    headers: headers(userEmail),
  });
  if (!res.ok) throw new Error((await res.json()).error || 'Failed to fetch daily brief');
  return res.json();
}
